export const DROPDOWN_CONTENT = [
  'Twitter',
  'Instagram',
  'Tiktok',
  'Google',
  'Friend / Referral',
  'Product Hunt',
];

export const OPTION_OTHER = 'Other';
